
// Step 3: Attach event listeners to wishlist buttons
document.addEventListener("DOMContentLoaded", function () {
    const productWishButtons = document.querySelector(".swym-button_product");
  

        productWishButtons.addEventListener("click", function () {
        const productId = productWishButtons.getAttribute("data-product-id");
        const variantId = productWishButtons.getAttribute("data-variant-id");
        const productUrl = productWishButtons.getAttribute("data-product-url");
  
        const product = {
          empi: productId,
          epi: variantId,
          du: productUrl,
        };
        console.log(product);
        
        productHandleSingleWishlist(product, productWishButtons);
      });

  });

  function productHandleSingleWishlist(product, button) {
    if (!window.globalListArray || !globalListArray[0]) {
      console.warn("Wishlist not ready yet. Try again shortly.");
      return;
    }
  
    const lid = globalListArray[0].lid;
  
    const onSuccess = function () {
      button.classList.toggle("swym-added");
      console.log(
        button.classList.contains("swym-added")
          ? "Product added to wishlist"
          : "Product removed from wishlist"
      );
    };
  
    const onError = function (error) {
      console.log("Error while adding/removing the product", error);
    };
  
    if (!button.classList.contains("swym-added")) { 
      _swat.addToList(lid, product, onSuccess, onError);
      console.log(product);
    //   wishPopNoti(product);
    } else {
      _swat.deleteFromList(lid, product, onSuccess, onError); 
    }
  }